//
//
//
//
//
//
//
//
//

export default {
    props: {
        url: {
            type: String
        },
        count: {
            type: [String, Number]
        }
    }
}
